<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#d7d7d7" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="servicelistItem">
        <div class="servicelistItemTop">
          <img class="servicelistItemImage" src="img/mine/kefu.png">
          <div class="servicelistItemText">{{this.$store.getters.getBaseInfo.name !==undefined ?this.$store.getters.getBaseInfo.name:this.$t("my.title")}}</div>
          <div class="servicelistItemBtn" @click="toServicePage()">
            <div class="servicelistItemBtnText">
              {{$t("my.contact")}}
            </div>
          </div>
        </div>
        <div class="servicelistItemBottom">
        <div class="servicelistItemInfoText">
          {{$t("my.service_time")}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    isIOS() {
      // 方法1：通过 userAgent 检测
      const ua = navigator.userAgent.toLowerCase();
      const isIOSUserAgent = /iphone|ipad|ipod/.test(ua);
      
      // 方法2：通过平台检测（更准确）
      const isIOSPlatform = /iPad|iPhone|iPod/.test(navigator.platform);
      
      // 方法3：检查触摸设备特征（iOS Safari 特有）
      const isTouchDevice = 'ontouchstart' in window;
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      
      return isIOSUserAgent || isIOSPlatform || (isTouchDevice && isSafari);
    },
    toServicePage(){
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1){
        if(this.isIOS()){

          window.location.href = service.kefu
        }else{
          window.open(service.kefu)

        }
      }
      // this.$router.push("ServicePage");
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.servicelistItem{
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: 30px 30px;
  margin: 30px 20px;
  border-radius: 20px;
  justify-content: space-between;
  background: #fff;
}
.servicelistItem .servicelistItemTop{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100px;
}
.servicelistItem .servicelistItemTop .servicelistItemImage{
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.servicelistItem .servicelistItemTop .servicelistItemText{
  margin-left: 50px;
  font-size: 43px;
  font-weight: 700;
  color: #000;
  flex: 1;
}
.servicelistItem .servicelistItemTop .servicelistItemBtn{
  display: flex;
  width: 150px;
  height: 55px;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #7030a0, #7030a0);
}
.servicelistItem .servicelistItemTop .servicelistItemBtn .servicelistItemBtnText{
  color: #ffffff;
  font-size: 25px;
}
.servicelistItem .servicelistItemBottom{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background: #ffffff;
  border-radius: 10px;
  color: #979799;
}
.servicelistItem .servicelistItemBottom .servicelistItemInfoText{
  font-size: 30px;
}
</style>
